const REVOKE_DELAY_MS = 30_000;
const MAX_STEM_LENGTH = 80;
// Safari drops a `download` name with control characters (a TTS title can hold a newline)
// and saves the file under a made-up name such as "example.com".
// eslint-disable-next-line no-control-regex
const UNSAFE_CHARS = /[\u0000-\u001f\u007f/\\:*?"<>|]+/g;

function safeFileName(name: string): string {
  const dot = name.lastIndexOf('.');
  const extension = dot > 0 ? name.slice(dot) : '';
  const stem = (dot > 0 ? name.slice(0, dot) : name)
    .replace(UNSAFE_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_STEM_LENGTH)
    .replace(/[\s.]+$/, '');
  return `${stem || 'file'}${extension}`;
}

function saveAs(href: string, name: string): void {
  const link = document.createElement('a');
  link.href = href;
  link.download = safeFileName(name);
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export async function downloadFile(url: string, name: string): Promise<void> {
  let blobUrl = '';
  try {
    const response = await fetch(url, { credentials: 'omit' });
    if (!response.ok) throw new Error(String(response.status));
    blobUrl = URL.createObjectURL(await response.blob());
  } catch {
    saveAs(url, name);
    return;
  }
  saveAs(blobUrl, name);
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), REVOKE_DELAY_MS);
}
